// extracted by mini-css-extract-plugin
export default {"tableList":"Table_tableList__DObue","tableMain":"Table_tableMain__3U4nb","cap":"Table_cap__7tZd9"};